<template>
  <div>
    <span class="user-msg">
      Hello, {{ $adal.user.profile.name }}
    </span>
    <router-link to="/">
      <span
        class="logout-icon"
        @click="onLogout"
        data-toggle="tooltip"
        data-placement="bottom"
        title="Logout"
        >
        <i class="fas fa-sign-out-alt" />
      </span>
    </router-link>
  </div>
</template>

<script>
import { AuthenticationContext } from "vue-adal";

export default {
  name: "Auth",
  created() {
    window.store.dispatch("updateUser", AuthenticationContext.user.profile);
  },
  methods: {
    onLogout: function () {
      AuthenticationContext.logout();
    },
  },
};
</script>
<style lang="scss" scoped>

  div{
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .user-msg{
    color: white;
  }

  .logout-icon{
    color: white;
    font-size: 25px;
  }

  @include media-breakpoint-down(sm) {
    .user-msg{
      display: none;
    }  
  }
</style>